module.exports = {
    "Clear search": `\u{AC80}\u{C0C9} \u{C9C0}\u{C6B0}\u{AE30}`
};


//# sourceMappingURL=ko-KR.main.js.map
